angular.module('llax')
    .controller('EditorContainerController', ['$rootScope', '$scope', '$routeParams', '$location', '$modal', '$timeout', 'ReactBridge',
        function($rootScope, $scope, $routeParams, $location, $modal, $timeout, ReactBridge) {

            $scope.showItems = function(task) {
                if (task.items && task.items.length === 1) {
                    $scope.task = task;
                    $scope.showEditor(task.items[0], task);
                } else {
                    $location.path("/browse").search("taskId", task.id);
                }
            };

            $scope.getBrowseLink = function(task) {
                if (!task) {
                    return "";
                }
                return 'browse?taskId=' + task.id;
            };

            $scope.openBrowseLink = function(task) {
                $location.path("/browse").search("taskId", task.id);
            };

            function useNewItemEditor() {
                if ($rootScope.useNextEditor && $rootScope.useNextEditor()) {
                    return true;
                }
                return !!($rootScope.hasSettingFeature && $rootScope.hasSettingFeature('NEXT_EDITOR'));
            }

            $scope.showEditor = function(primaryKey, task) {
                var path = $location.path();
                // A task still needs the classic editor's "Save and close task"
                // actions. The next editor broadcasts itemEditorClosed without
                // taskOptions, so opening it here drops that flow.
                if (!task && useNewItemEditor()) {
                    var mount = document.getElementById('next-item-editor');
                    if (!mount) {
                        mount = document.createElement('div');
                        mount.id = 'next-item-editor';
                        document.body.appendChild(mount);
                    }
                    var dialog = ReactBridge.mountDialog('ItemEditorDialog', '#next-item-editor', {
                        primaryKey: primaryKey,
                        task: task,
                        onClose: function() {
                            $location.displayUrl(path);
                            if (dialog && angular.isFunction(dialog.unmount)) {
                                dialog.unmount();
                            }
                        },
                        openItemEditor: function(item) {
                            var nextKey = item && (item.primaryKey__ || item.primaryKey || item);
                            $timeout(function() {
                                $scope.showEditor(nextKey, task);
                            }, 200);
                        }
                    });
                    return;
                }
                var editor = $modal.open({
                    templateUrl: 'tpl/editor.tpl.html',
                    controller: 'EditorController',
                    backdrop: 'static',
                    keyboard: true,
                    windowClass: 'item-editor',
                    resolve: {
                        params: function() {
                            return {
                                itemPrimaryKey: primaryKey,
                                task: task
                            };
                        }
                    }
                });
                editor.result.then(function(response) {
                    // Start the editor with another item
                    if (!_.isNil(response.showItemPrimaryKey)) {
                        $timeout(function() {
                            $scope.showEditor(response.showItemPrimaryKey,task);
                        }, 1);
                    }
                }).finally(function() {
                    $location.displayUrl(path);
                });
            };

        }
    ]);
